<template>
  <div v-if="linkData">
    <router-link
      v-slot="{ navigate, href }"
      :to="linkData.to"
      class="menu-item"
      :data-cy="linkData.e2eLabel"
      custom
      @click.native="handleClick"
    >
      <div v-if="linkData.subItems">
        <span class="icon-container">
          <component :is="linkData.icon" />
        </span>
        <span class="label">{{ linkData.label }}</span>
        <span v-if="linkData.subItems" class="extra" :class="caretClass">
          <ChevronLeft size="22" />
        </span>
      </div>

      <div
        v-else
        :active="isCurrentRoute"
        :href="href"
        :class="{ 'router-link-exact-active': isCurrentRoute }"
        @click="navigate"
      >
        <span class="icon-container">
          <component :is="linkData.icon" />
        </span>
        <span class="label">{{ linkData.label }}</span>
      </div>
    </router-link>
    <div
      v-if="linkData.subItems"
      ref="subMenu"
      class="sub-items"
      :style="subMenuStyles"
    >
      <div v-for="item of linkData.subItems" :key="item.label">
        <router-link :to="item.to" class="menu-item">
          {{ item.label }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ChevronLeft } from 'lucide-vue'

export default {
  components: {
    ChevronLeft
  },
  props: {
    linkData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      subMenuHeight: 0
    }
  },
  computed: {
    isCurrentRoute() {
      return this.$route.name === this.linkData.to.name
    },
    caretClass() {
      return this.isOpen ? 'opened' : ''
    },
    subMenuStyles() {
      return {
        height: this.isOpen ? `${this.subMenuHeight}px` : '0px'
      }
    }
  },
  mounted() {
    if (this.$refs.subMenu) {
      this.subMenuHeight = this.$refs.subMenu.scrollHeight
    }
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
    handleClick(e) {
      if (this.$props.linkData.subItems) {
        e.preventDefault()
        this.toggleOpen()
      }
      if (this.linkData.to.name === this.$route.name) this.$emit('closeMenu')
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-item {
  color: $white;
  padding: 10px;
  margin: 10px 15px;
  transition: 200ms background-color ease-in-out;
  background-color: transparent;
  font-family: $accent-font-family;

  color: $white;
  display: flex;
  align-items: center;

  // The :hover rule below is (0,2,0) and comes later, so a bare
  // `.router-link-exact-active` tied it and LOST -- hovering the row you are
  // already on faded it from 12% down to 6%, toward the unselected rows.
  // Naming the hover permutation here settles it at (0,3,0) instead of relying
  // on which rule is written last.
  &.router-link-exact-active,
  &.router-link-exact-active:hover {
    background: $color-overlay-medium;
    box-shadow: 0px 3px 6px #00000087;
    border-radius: 6px;
  }

  &:hover {
    background-color: $color-overlay-subtle;
    cursor: pointer;
  }
}

.icon-container {
  margin: 0 15px;
  .svg {
    font-size: 21px;
    margin-right: 25px;
  }
}

.label {
  flex: 1;
  text-decoration: none;
}

.sub-items {
  color: $white;
  background: $color-overlay-subtle;
  overflow: hidden;
  transition: height 222ms ease-in-out;
}

.sub-item {
  margin-left: 50px;
  font-weight: bold;
  padding: 15px 0 15px 15px;
  background-color: transparent;
  transition: 200ms background-color ease-in-out;

  &.active {
    background-color: $color-overlay-medium;
  }

  &:hover {
    background-color: $color-overlay-subtle;
    cursor: pointer;
  }
}

.extra {
  transition: transform 222ms ease-in-out;

  &.opened {
    transform: rotate(-90deg);
  }
}
</style>
